import React from 'react';

import {Skeleton} from '@optimaxdev/design-system';

import s from './cartItemFaceliftSkeleton.scss';

/**
 * Skeleton for checkout facelift sidebar
 */
export const CartItemFaceliftSkeleton = () => {
    return (
        <div className={s.skeletonLayout}>
            <div className={s.header}>
                <Skeleton className={s.headerLeft} height={20} radius="100px" width={104} />
                <Skeleton className={s.headerRight} height={20} radius="100px" width={62} />
            </div>

            <div className={s.main}>
                <Skeleton height={136} width={136} />
                <div className={s.textBlock}>
                    <Skeleton height={22} radius="100px" width={115} />
                    <Skeleton className={s.mt4} height={22} radius="100px" width={73} />
                    <Skeleton className={s.mt10} height={22} radius="100px" width={73} />
                    <Skeleton className={s.mt16} height={22} radius="100px" width={152} />
                </div>
            </div>

            <div className={s.section}>
                <div className={s.left}>
                    <Skeleton height={22} radius="100px" width={132} />
                    <Skeleton height={22} radius="100px" width={108} />
                    <Skeleton height={22} radius="100px" width={132} />
                    <Skeleton height={22} radius="100px" width={108} />
                </div>
                <div className={s.right}>
                    <Skeleton height={22} radius="100px" width={62} />
                    <Skeleton height={22} radius="100px" width={62} />
                    <Skeleton height={22} radius="100px" width={62} />
                    <Skeleton height={22} radius="100px" width={62} />
                </div>
            </div>

            <div className={s.footer}>
                <Skeleton height={24} radius="100px" width={132} />
                <Skeleton height={24} radius="100px" width={62} />
            </div>
        </div>
    );
};
